import { Button } from '@zorro/design-system/v2/Button';
import { Title } from '@zorro/design-system/v2/Title';
import { LogoDark } from '@zorro/shared/assets';
import { Box, Stack, Text } from '@zorro/web/design-system';

export const InviteByEmailDecoration = () => {
  return (
    <>
      <LogoDark />
      <Stack
        style={{ borderRadius: '16px 16px 0 0' }}
        bg="zorroWhite.0"
        h="100%"
        p="2rem"
      >
        <Text fw={500} c="zorroSky.5">
          Action required
        </Text>
        <Text fw={500} mt="xl" c="zorroGray.4">
          Welcome to Zorro!
        </Text>
        <Title>Complete your company profile on Zorro to get set up</Title>
        <Box style={{ borderRadius: '16px' }} bg="#D9DBDF" w="152px" h="9px" />
        <Box style={{ borderRadius: '16px' }} bg="#D9DBDF" h="9px" />
        <Button size="xs" mt="lg" isHoverDisabled>
          <Text fs="1rem" c="white">
            Set up your company
          </Text>
        </Button>
      </Stack>
    </>
  );
};
